import SchemaCard from "./SchemaCard";
import PersonalTrainingCard from "./PersonalTrainingCard";

export default function ProductsSection() {
  return (
    <section id="aanbod" data-testid="products-section" className="py-20 lg:py-28 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <p className="overline mb-3">Kies jouw start</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            Alles wat je nodig hebt om te starten
          </h2>
          <p className="text-zinc-400 text-base max-w-2xl mx-auto">
            Of je nu meteen wilt starten met een persoonlijk schema of voor een schema op maat wilt gaan — kies wat bij jou past.
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-7 items-stretch max-w-4xl mx-auto">
          <SchemaCard />
          <PersonalTrainingCard />
        </div>
      </div>
    </section>
  );
}
